import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ApiServiceService } from "../../../../../Services/api-service.service";
import * as alertify from "alertifyjs";
import { toTitleCase } from "src/app/Module/executive/components/taxpayer-performance-dashboard/taxpayer-modal/taxpayer-modal.component";
import { phoneNumberValidator } from "src/app/Shared/phone-number.validator";
import { DateAdapter } from "@angular/material/core";
import { MatDatepicker } from "@angular/material/datepicker";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-basic-information",
  templateUrl: "./basic-information.component.html",
  styleUrls: ["./basic-information.component.css"],
  providers: [DatePipe],
})
export class BasicInformationComponent {

  isLoading: boolean = false;
  basicForm: any;
  @Input() biodata: any;
  @Output() basicDetails = new EventEmitter<{}>();
  area: any[] = [];
  state2: any[] = [];
  lga2: any[] = [];
  area2: any[] = [];
  sourceOfIncome: any[] = [];
  years: any[] = [];
  mediaOptions = ["SSCE", "OND", "DIPLOMA", "HND", "BSC", "MSC", "PHD"];
  assetsOptions = ["Land", "Livestock", "Houses", "Others", "Vehicles"];


  businessForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private apiService: ApiServiceService,
    private dateAdapter: DateAdapter<Date>,
    private datePipe: DatePipe
  ) { }

  screenHeight = window.screen.height - 271; // 1058
  minHeight = "min-height: " + this.screenHeight + "px !important";

  screenHeight2 = window.screen.height - 630; // 428
  minHeight2 = "min-height: " + this.screenHeight2 + "px !important";

  @Output() states = new EventEmitter<{ state: boolean }>();

  ngOnInit() {
    const currentYear = new Date().getFullYear() + 1;

    this.businessForm = this.fb.group({
      businessName: ['', Validators.required],
      businessASIN: ['', Validators.required]
    })

    this.basicForm = this.fb.group({
      incomeCategory: [""],
      employerName: [""],
      incomeRange: [""],
      sourceOfIncome: [""],
      totalAnnualIncome: [""],
      closestTaxOffice: [""],
      numberOfVehicles: [""],
      natureOfBusiness: [""],
      educationLevel: [""],

      hasVehicle: [""],
      hasProperty: [""],
      propertyType: [null],


      // CONTACT
      email: ["", [Validators.email]],
      state: [""],
      stateOfOrigin: [""],
      lgaOfOrigin: [""],
      lga: [""],
      address: [""],
      landMark: [""],

      // RENT
      accommodationType: [""],
      buildingType: [""],
      rentPeriodCovered: [""],
      periodType: [""],
      propertyManagement: [""],
      annualRentAmount: [""],
      asin: [""],
      numberOfRooms: [""],
      rentPeriodCoveredStart: [""],
      rentPeriodCoveredEnd: [""],

      // LANDLORD
      landlordFullName: [""],
      landlordPhoneNumber: ["", phoneNumberValidator],
      landlordAsin: [""],
      landlordEmail: ["", Validators.email],
      doesLandlordLiveSameApartment: [""],
      landlordAddress: [""],

      hasBusiness: ["", [Validators.required]],
      businesses: [[], Validators.required]
    });
    console.log(this.biodata);
    const startYear = 2000; // or whatever lower limit you want
    for (let y = currentYear; y >= startYear; y--) {
      this.years.push(y);
    }

    this.getState();
    this.getOccupation();
    this.getAllBusinessNature();
  }

  businessNatureList: any[];
  getAllBusinessNature() {
    this.apiService.LoginGet("/auth/utility/business_nature/all").subscribe(
      (reponse) => {
        this.businessNatureList = reponse;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  submit() {
    this.isLoading = true;
    // this.apiServer.loginPost_('', this.basicForm.value).subscribe(res => {
    this.states.emit({ state: true });
    this.basicDetails.emit(this.basicForm.value);

    console.log(this.basicForm.value);
  }

  add() {
    const businesses = [...this.basicForm.get('businesses').value];
    this.basicForm.get('businesses').setValue([...businesses, this.businessForm.value])
    this.businessForm.reset()
  }

  remove(i: number) {
    const businesses = this.basicForm.get('businesses')?.value || [];
    const updated = businesses.filter((_: any, index: number) => index !== i);
  
    this.basicForm.get('businesses')?.setValue(updated);
  }

  public getOccupation() {
    this.apiService.LoginGet(`/auth/occupation/all`, {}).subscribe((res) => {
      this.sourceOfIncome = res;
    });
  }

  get ninControl() {
    return this.basicForm?.get("nin");
  }

  isValidatingNin: boolean;
  ninDetails: any;
  ninMismatchError: any;
  isNinValidated: boolean;
  validateNIN() {
    const value = this.basicForm.value;
    this.isValidatingNin = true;
    this.ninMismatchError = null;

    this.isNinValidated = false;
    this.ninDetails = null;
    this.apiService
      .get(`/assessments/nin/match?nin=${value.nin}&asin=${""}`)
      .subscribe(
        (res: any) => {
          if (res.success) {
            this.ninDetails = res.data;
            this.isNinValidated = true;
            alertify.success("NIN Validated Successfully");

            this.basicForm.patchValue({
              ninFirstName: res.data.first_name,
              ninLastName: res.data.last_name,
              ninMiddleName: res.data.middle_name,
              ninPhoneNumber: res.data.phone_number,
            });
          } else {
            this.ninMismatchError = res.message || "NIN is invalid";
          }
          this.isValidatingNin = false;
        },
        (error) => {
          this.isValidatingNin = false;
        }
      );
  }

  state: any;
  getState() {
    this.apiService.LoginGet("/auth/state/all", {}).subscribe((res) => {
      this.state = res.map((state: any) => ({
        ...state,
        name: toTitleCase(state.name),
      }));
    });
  }
  onStateChange() {
    this.getLga(this.basicForm.get("state").value?.id);
    this.basicForm.get("lga").reset();
  }
  onStateOfOriginChange() {
    this.getLga(this.basicForm.get("stateOfOrigin").value?.id);
    this.basicForm.get("lgaOfOrigin").reset();
  }

  lgas: any;
  getLga(stateId: any) {
    this.apiService
      .LoginGet(`/auth/lga/state/all/${stateId}`, {})
      .subscribe((res) => {
        this.lgas = res;
      });
  }

  chosenMonthHandler(normalizedMonth: Date, datepicker: any) {
    const ctrlValue = new Date(normalizedMonth);
    ctrlValue.setDate(1); // force day=1
    if (!this.basicForm.value.rentPeriodCoveredStart) {
      this.basicForm.patchValue({ rentPeriodCoveredStart: ctrlValue });
    } else {
      this.basicForm.patchValue({ rentPeriodCoveredEnd: ctrlValue });
    }
    let start = this.basicForm.get("rentPeriodCoveredStart")?.value;
    let end = this.basicForm.get("rentPeriodCoveredEnd")?.value;

    let dates = this.getFormattedRentPeriod(start, end);
    this.basicForm.patchValue({ rentPeriodCovered: dates });

    datepicker.close();
  }

  getFormattedRentPeriod(startDate: any, endDate: any): string {
    if (!startDate || !endDate) return "";

    const formattedStart = this.datePipe.transform(startDate, "mediumDate");
    const formattedEnd = this.datePipe.transform(endDate, "mediumDate");

    return `${formattedStart} – ${formattedEnd}`;
  }
}
